/**
 * TanStack Router: /workforce/roles
 *
 * This route file was auto-generated by the route generation script.
 * Component: WorkforceRolesPage
 * Layout: Authenticated (_auth)
 *
 * @see scripts/generate-routes.ts
 * @see docs/architecture/tanstack-router-migration-architecture.md
 */
import { createFileRoute } from '@tanstack/react-router'
import WorkforceRolesPage from '@/app/workforce/roles/page'

/**
 * Route: /workforce/roles
 * Layout: _auth (authenticated)
 * Component: WorkforceRolesPage
 */
export const Route = createFileRoute('/_auth/workforce/roles/')({
  component: WorkforceRolesPage,
})
